import { InvisalignForTeensPage } from "~/components/invisalign-for-teens/InvisalignForTeensPage";
import { createFileRoute } from "@tanstack/react-router";
import { breadcrumbSchema, structuredDataScript } from "~/utils/structuredData";

const title =
	"Invisalign for Teens | Miami Invisalign | Miami Ortho Specialists";
const description =
	"Teens lead active and busy lives, and braces may not always be the best choice for everyone. We're proud to offer Invisalign for teens.";

export const Route = createFileRoute("/invisalign-for-teens")({
	head: () => ({
		links: [
			{
				rel: "canonical",
				href: "https://miamibraces.com/invisalign-for-teens/",
			},
		],
		meta: [
			{ title },
			{ name: "description", content: description },
			{
				name: "robots",
				content:
					"index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
			},
			{ property: "og:locale", content: "en_US" },
			{ property: "og:type", content: "article" },
			{ property: "og:title", content: title },
			{ property: "og:description", content: description },
			{
				property: "og:url",
				content: "https://miamibraces.com/invisalign-for-teens/",
			},
			{
				property: "og:site_name",
				content: "Miami Orthodontic Specialists",
			},
			{
				property: "article:publisher",
				content: "https://www.facebook.com/miamibraces/",
			},
			{
				property: "article:modified_time",
				content: "2022-03-01T18:51:15+00:00",
			},
			{
				property: "og:image",
				content: "https://miamibraces.com/invisalign-for-teens.jpg",
			},
			{ property: "og:image:width", content: "2000" },
			{ property: "og:image:height", content: "1335" },
			{ property: "og:image:type", content: "image/jpeg" },
			{ name: "twitter:card", content: "summary_large_image" },
			{ name: "twitter:label1", content: "Est. reading time" },
			{ name: "twitter:data1", content: "4 minutes" },
		],
		scripts: [
			structuredDataScript([
				breadcrumbSchema(
					"https://miamibraces.com/invisalign-for-teens/",
					"Invisalign for Teens",
				),
			]),
		],
	}),
	component: InvisalignForTeensPage,
});
